import { globalAlertActions } from './GlobalAlert.actions';
type Action = {
  type: string;
  message?: string;
};
export const globalAlert = (state = null, action: Action) => {
  switch (action.type) {
    case globalAlertActions.set:
      return action.message;
    case globalAlertActions.remove:
      return null;
    default:
      return state;
  }
};
